import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_ALARM_NOTIFICATION_PROFILE = '/alarm-noti-profiles';
export const API_PATH_ALARM_INTERCEPT = '/alarms-intercept';
export const API_PATH_ALARM_DEFINITION = '/alarms-def';
export const API_PATH_ACTIVE_ALARM_INSTANCE = '/alarms';

export const SET_ALARM_NOTIFICATION_PROFILE_LOADING = 'SET_ALARM_NOTIFICATION_PROFILE_LOADING';
export const GO_TO_ALARM_NOTIFICATION_PROFILE_CREATE = 'GO_TO_ALARM_NOTIFICATION_PROFILE_CREATE';
export const GO_TO_ALARM_NOTIFICATION_PROFILE_EDIT = 'GO_TO_ALARM_NOTIFICATION_PROFILE_EDIT';
export const GO_TO_ALARM_NOTIFICATION_PROFILE_VIEW = 'GO_TO_ALARM_NOTIFICATION_PROFILE_VIEW';
export const GO_TO_ALARM_NOTIFICATION_PROFILE_COPY = 'GO_TO_ALARM_NOTIFICATION_PROFILE_COPY';
export const GO_TO_ALARM_NOTIFICATION_PROFILE_LIST = 'GO_TO_ALARM_NOTIFICATION_PROFILE_LIST';
export const GET_ALARM_NOTIFICATION_PROFILE_LIST = 'GET_ALARM_NOTIFICATION_PROFILE_LIST';
export const GET_ALARM_NOTIFICATION_PROFILE_LIST_PENDING = 'GET_ALARM_NOTIFICATION_PROFILE_LIST_PENDING';
export const GET_ALARM_NOTIFICATION_PROFILE_LIST_FULFILLED = 'GET_ALARM_NOTIFICATION_PROFILE_LIST_FULFILLED';
export const GET_ALARM_NOTIFICATION_PROFILE = 'GET_ALARM_NOTIFICATION_PROFILE';
export const GET_ALARM_NOTIFICATION_PROFILE_PENDING = 'GET_ALARM_NOTIFICATION_PROFILE_PENDING';
export const GET_ALARM_NOTIFICATION_PROFILE_FULFILLED = 'GET_ALARM_NOTIFICATION_PROFILE_FULFILLED';
export const CREATE_ALARM_NOTIFICATION_PROFILE = 'CREATE_ALARM_NOTIFICATION_PROFILE';
export const CREATE_ALARM_NOTIFICATION_PROFILE_PENDING = 'CREATE_ALARM_NOTIFICATION_PROFILE_PENDING';
export const CREATE_ALARM_NOTIFICATION_PROFILE_FULFILLED = 'CREATE_ALARM_NOTIFICATION_PROFILE_FULFILLED';
export const CREATE_ALARM_NOTIFICATION_PROFILE_REJECTED = 'CREATE_ALARM_NOTIFICATION_PROFILE_REJECTED';
export const UPDATE_ALARM_NOTIFICATION_PROFILE = 'UPDATE_ALARM_NOTIFICATION_PROFILE';
export const UPDATE_ALARM_NOTIFICATION_PROFILE_FULFILLED = 'UPDATE_ALARM_NOTIFICATION_PROFILE_FULFILLED';
export const UPDATE_ALARM_NOTIFICATION_PROFILE_REJECTED = 'UPDATE_ALARM_NOTIFICATION_PROFILE_REJECTED';
export const DELETE_ALARM_NOTIFICATION_PROFILE = 'DELETE_ALARM_NOTIFICATION_PROFILE';
export const DELETE_ALARM_NOTIFICATION_PROFILE_FULFILLED = 'DELETE_ALARM_NOTIFICATION_PROFILE_FULFILLED';
export const DELETE_ALARM_NOTIFICATION_PROFILE_REJECTED = 'DELETE_ALARM_NOTIFICATION_PROFILE_REJECTED';
export const SELECT_ALARM_NOTIFICATION_PROFILE = 'SELECT_ALARM_NOTIFICATION_PROFILE';
export const GET_INTERCEPT_ALARM_LIST = 'GET_INTERCEPT_ALARM_LIST';
export const GET_INTERCEPT_ALARM_LIST_PENDING = 'GET_INTERCEPT_ALARM_LIST_PENDING';
export const GET_INTERCEPT_ALARM_LIST_FULFILLED = 'GET_INTERCEPT_ALARM_LIST_FULFILLED';
export const GET_ALARMS_INST_LIST = 'GET_ALARMS_INST_LIST';
export const GET_ALARMS_INST_LIST_PENDING = 'GET_ALARMS_INST_LIST_PENDING';
export const GET_ALARMS_INST_LIST_FULFILLED = 'GET_ALARMS_INST_LIST_FULFILLED';
export const GET_ALARMS_DEF_LIST = 'GET_ALARMS_DEF_LIST';
export const GET_ALARMS_DEF_LIST_PENDING = 'GET_ALARMS_DEF_LIST_PENDING';
export const GET_ALARMS_DEF_LIST_FULFILLED = 'GET_ALARMS_DEF_LIST_FULFILLED';

export enum AlarmNotificationProfilePrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export enum AlarmNotificationProfileMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export interface AlarmNotificationProfile {
  id?: string,
  alarmNtfyProfileId: string,
  name: string,
  profile_type: 'ALARM_DEFINITION' | 'ALARM_INSTANCE' | 'INTERCEPT_ALARM',
  email: string,
  alarm_definition: string,
  alarm_instance: string,
  survindex: string,
  frequency: string,
  last_mailing_time: string,
}

// export interface AlarmNotificationProfileGridData {
//   id?: string,
//   name: string,
//   content_type: string,
// }

export interface AdaptedAlarmNotificationProfile {
  alarmNtfyProfileId?: string,
  name: string,
  email: string[],
  profile_type: 'ALARM_DEFINITION' | 'ALARM_INSTANCE' | 'INTERCEPT_ALARM',
  frequency: string,
  alarmsDef?: AlarmsDef[],
  alarmsInst?: AlarmsInst[],
  interceptAlarm?: InterceptAlarm[],
  last_mailing_time: string,
}

export interface AlarmsDef {
  id?: string,
  alarmId: string,
}

export interface AlarmsInst {
  id?: string, // alarmGrpId|instance
  alarmid: string,
  instance: string,
}

export interface InterceptAlarm {
  id?: string, // survindex
  coId?: string,
  caseId?: string,
  survIndex: string, // unique
}

export interface Frequency {
  value: string,
  type: string,
}

export interface AlarmNotificationProfileNumList {
  id: number
  cid: number
  callingnum: string
}

export interface AlarmNotificationProfileState {
  entities: AlarmNotificationProfile[]
  selected: AdaptedAlarmNotificationProfile[],
  single: AlarmNotificationProfile | null
  createdId: string | null
  ui: AlarmNotificationProfilesUIState
  interceptAlarmList: InterceptAlarm[],
  alarmsInstList: AlarmsInst[],
  alarmsDefList: AlarmsDef[],
}

export interface AlarmNotificationProfilesUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToAlarmNotificationProfileListAction extends AnyAction {
  type: typeof GO_TO_ALARM_NOTIFICATION_PROFILE_LIST
}

export interface SetAlarmNotificationProfileLoadingAction extends AnyAction {
  type: typeof SET_ALARM_NOTIFICATION_PROFILE_LOADING
  payload: { isLoading: boolean }
}

export interface GetAlarmNotificationProfileListAction extends AnyAction {
  type: typeof GET_ALARM_NOTIFICATION_PROFILE_LIST
  payload: AxiosPromise<ServerResponse<AlarmNotificationProfile>>
}

export interface GetAlarmNotificationProfileListPendingAction extends AnyAction {
  type: typeof GET_ALARM_NOTIFICATION_PROFILE_LIST_PENDING
  payload: null
}

export interface GetAlarmNotificationProfileListFulfilledAction extends AnyAction {
  type: typeof GET_ALARM_NOTIFICATION_PROFILE_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface GetAlarmNotificationProfileAction extends AnyAction {
  type: typeof GET_ALARM_NOTIFICATION_PROFILE
  payload: AxiosPromise<ServerResponse<AlarmNotificationProfile>>
}

export interface GetAlarmNotificationProfilePendingAction extends AnyAction {
  type: typeof GET_ALARM_NOTIFICATION_PROFILE_PENDING
  payload: null
}

export interface GetAlarmNotificationProfileFulfilledAction extends AnyAction {
  type: typeof GET_ALARM_NOTIFICATION_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface CreateAlarmNotificationProfileThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateAlarmNotificationProfileAction extends AnyAction {
  type: typeof CREATE_ALARM_NOTIFICATION_PROFILE
  payload: AxiosPromise<ServerResponse<AlarmNotificationProfile>>
}

export interface CreateAlarmNotificationProfilePendingAction extends AnyAction {
  type: typeof CREATE_ALARM_NOTIFICATION_PROFILE_PENDING
  payload: null
}

export interface CreateAlarmNotificationProfileFulfilledAction extends AnyAction {
  type: typeof CREATE_ALARM_NOTIFICATION_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface CreateAlarmNotificationProfileRejectedAction extends AnyAction {
  type: typeof CREATE_ALARM_NOTIFICATION_PROFILE_REJECTED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface UpdateAlarmNotificationProfileThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface UpdateAlarmNotificationProfileAction extends AnyAction {
  type: typeof UPDATE_ALARM_NOTIFICATION_PROFILE
  payload: AxiosPromise<ServerResponse<AlarmNotificationProfile>>
}

export interface UpdateAlarmNotificationProfileFulfilledAction extends AnyAction {
  type: typeof UPDATE_ALARM_NOTIFICATION_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface UpdateAlarmNotificationProfileRejectedAction extends AnyAction {
  type: typeof UPDATE_ALARM_NOTIFICATION_PROFILE_REJECTED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface DeleteAlarmNotificationProfileThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface DeleteAlarmNotificationProfileAction extends AnyAction {
  type: typeof DELETE_ALARM_NOTIFICATION_PROFILE
  payload: AxiosPromise<ServerResponse<AlarmNotificationProfile>>
}

export interface DeleteAlarmNotificationProfileFulfilledAction extends AnyAction {
  type: typeof DELETE_ALARM_NOTIFICATION_PROFILE_FULFILLED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface DeleteAlarmNotificationProfileRejectedAction extends AnyAction {
  type: typeof DELETE_ALARM_NOTIFICATION_PROFILE_REJECTED
  payload: AxiosResponse<ServerResponse<AlarmNotificationProfile>>
}

export interface SelectAlarmNotificationProfileAction extends AnyAction {
  type: typeof SELECT_ALARM_NOTIFICATION_PROFILE
  payload: AdaptedAlarmNotificationProfile[]
}

export interface GetInterceptAlarmListAction extends AnyAction {
  type: typeof GET_INTERCEPT_ALARM_LIST
  payload: AxiosPromise<ServerResponse<InterceptAlarm>>
}

export interface GetInterceptAlarmListPendingAction extends AnyAction {
  type: typeof GET_INTERCEPT_ALARM_LIST_PENDING
  payload: null
}

export interface GetInterceptAlarmListFulfilledAction extends AnyAction {
  type: typeof GET_INTERCEPT_ALARM_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<InterceptAlarm>>
}

export interface GetAlarmsInstListAction extends AnyAction {
  type: typeof GET_ALARMS_INST_LIST
  payload: AxiosPromise<ServerResponse<AlarmsInst>>
}

export interface GetAlarmsInstListPendingAction extends AnyAction {
  type: typeof GET_ALARMS_INST_LIST_PENDING
  payload: null
}

export interface GetAlarmsInstListFulfilledAction extends AnyAction {
  type: typeof GET_ALARMS_INST_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<AlarmsInst>>
}

export interface GetAlarmsDefListAction extends AnyAction {
  type: typeof GET_ALARMS_DEF_LIST
  payload: AxiosPromise<ServerResponse<AlarmsDef>>
}

export interface GetAlarmsDefListPendingAction extends AnyAction {
  type: typeof GET_ALARMS_DEF_LIST_PENDING
  payload: null
}

export interface GetAlarmsDefListFulfilledAction extends AnyAction {
  type: typeof GET_ALARMS_DEF_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<AlarmsDef>>
}

export type AlarmNotificationProfileActionTypes =
  GoToAlarmNotificationProfileListAction |
  SetAlarmNotificationProfileLoadingAction |
  GetAlarmNotificationProfileListAction |
  GetAlarmNotificationProfileListPendingAction |
  GetAlarmNotificationProfileListFulfilledAction |
  GetAlarmNotificationProfileAction |
  GetAlarmNotificationProfilePendingAction |
  GetAlarmNotificationProfileFulfilledAction |
  GetInterceptAlarmListAction |
  GetInterceptAlarmListPendingAction |
  GetInterceptAlarmListFulfilledAction |
  GetAlarmsInstListAction |
  GetAlarmsInstListPendingAction |
  GetAlarmsInstListFulfilledAction |
  GetAlarmsDefListAction |
  GetAlarmsDefListPendingAction |
  GetAlarmsDefListFulfilledAction |
  CreateAlarmNotificationProfileAction |
  CreateAlarmNotificationProfilePendingAction |
  CreateAlarmNotificationProfileFulfilledAction |
  CreateAlarmNotificationProfileRejectedAction |
  UpdateAlarmNotificationProfileAction |
  UpdateAlarmNotificationProfileFulfilledAction |
  UpdateAlarmNotificationProfileRejectedAction |
  DeleteAlarmNotificationProfileAction |
  DeleteAlarmNotificationProfileFulfilledAction |
  DeleteAlarmNotificationProfileRejectedAction |
  SelectAlarmNotificationProfileAction;
